import {
  EXAM_PASSWORD_DUPLICATED_MESSAGE,
  isExamPasswordDuplicatedError,
} from "./managementApiError";

export const validateCompanyCreateForm = (formData) => {
  if (!formData.companyName.trim()) {
    return "会社名を入力してください。";
  }
  if (!formData.examPassword.trim()) {
    return "試験用パスワードを入力してください。";
  }
  return "";
};

// 会社登録APIには会社名と試験パスワードだけを送信する。
export const buildCompanyCreatePayload = (formData) => ({
  company_name: formData.companyName.trim(),
  exam_password: formData.examPassword,
});

export const getCompanyCreateErrorMessage = (error) => {
  const status = error?.status ?? error?.response?.status;

  // 試験用パスワード重複も同じ409なので、会社名重複の文言を出さないようコードで先に判定する。
  if (isExamPasswordDuplicatedError(error)) {
    return EXAM_PASSWORD_DUPLICATED_MESSAGE;
  }

  if (status === 400) {
    return "入力内容を見直してください。";
  }
  if (status === 403) {
    return "会社を登録する権限がありません。";
  }
  if (status === 409) {
    return "同じ会社名がすでに登録されています。";
  }
  return "会社の登録に失敗しました。時間を置いて再試行してください。";
};
